export const getMaxValue = (data) => {
    const maxItemsArr = data.map(({ data: innerData }) => innerData.reduce((previous, current) => (current[1] > previous ? current[1] : previous), 0));
    return Math.max.apply(null, maxItemsArr);
};
//# sourceMappingURL=getMaxValue.js.map